import { UIText2 } from '@cian/ui-kit';

import cn from 'classnames';
import * as React from 'react';

import { EAreaPartsField } from '../../../../../enums';
import { AreaPartInput } from '../../../../AreaPartInput/AreaPartInput';

import { PriceType } from '../PriceType/PriceType';

import { PriceProps } from './types';

import * as styles from './Price.css';
import { Field } from '../Field';

export const Price: React.FC<PriceProps> = props => {
  const { invalidFields, id, isMobile, isSale, onChange, onValidate, price, priceCaption, priceType, captionColor } =
    props;

  return (
    <div className={cn(styles['root'], isMobile && styles['mobile'])}>
      <div>
        <Field invalidFields={invalidFields} name={EAreaPartsField.Price} onValidate={onValidate}>
          <AreaPartInput
            id={id}
            name={EAreaPartsField.Price}
            value={price}
            maxWidth={166}
            minValue={1}
            rightAdornment="₽"
            onChange={onChange}
          />
        </Field>
        <div className={styles['price-type']}>
          <PriceType isSale={isSale} value={priceType} isMobile={isMobile} onChange={onChange} />
        </div>
      </div>
      <UIText2 color={captionColor}>{`Итого: ${priceCaption ?? '0 ₽'}`}</UIText2>
    </div>
  );
};
